var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"placeholderLink",staticClass:"home-placeholder-element",style:({ 'height': _vm.homeHeight + 'px' })},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"element-inner"},[_c('div',{staticClass:"inner-text"},[_c('div',{staticClass:"text-inner"},[_vm._v("COMING SOON")])])])
}]

export { render, staticRenderFns }